import styled from '../../styled-components';

export const HeadingLevel1 = styled.h1<{ bold?: boolean }>`
    margin: 0;
    font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
    font-size: 3.2rem;
    color: ${({ theme }) => theme.colors.dark};
`;
